import Enlace from "./Enlace";
import Imagen from "./Imagen";

class Actividad {

    idModal: string;

    titulo: string;

    descripcion: string[];

    tituloLista: string | undefined;

    elementosLista: string[] | undefined;

    enlacesInteres: Enlace[] | undefined;

    icono: string;

    tipoIcono: string;

    imagenes: Imagen[];

    constructor(idModal:string, titulo: string, descripcion: string[], icono: string, tipoIcono: string, imagenes: Imagen[], tituloLista?: string, elementosLista?: string[], enlacesInteres?: Enlace[]) {
      this.idModal = idModal;
      this.titulo = titulo;
      this.descripcion = descripcion;
      this.icono = icono;
      this.tipoIcono = tipoIcono;
      this.imagenes = imagenes;
      this.tituloLista = tituloLista;
      this.elementosLista = elementosLista;
      this.enlacesInteres = enlacesInteres;
    }

}

export default Actividad;